import React from 'react'

import { Center, Section } from '../styled'

import { SectionTitle } from './styled'

const Hero = () => {
  return (
    <Section dark>
    	<Center>
        <SectionTitle>
          See what our customers have to say about<span translate="no"> Fellow</span>.
        </SectionTitle>
      </Center>
    </Section>
  )
}

export default Hero
